import { APP_STYLE_BACKSLASH_REPLACEMENT } from '../constants';

export const getStyleClassNames = (
  raw: string | undefined,
  scopeId?: string
): string => {
  if (typeof raw !== 'string' || !raw.trim()) return '';

  const keys = raw
    .split(',')
    .map((key) => key.trim().replace(/\\/g, APP_STYLE_BACKSLASH_REPLACEMENT))
    .filter(Boolean);

  return keys
    .flatMap((key) => (scopeId ? [key, `${scopeId}_${key}`] : [key]))
    .join(' ');
};
